export default __webpack_public_path__ + "static/media/telesaleshelp-form.6e8627c1.PNG";